

import {Box, Skeleton} from '@betty/moonlight'

import styles from './MainLabelSkeleton.module.css'

function MainLabelSkeleton() {
  return (
    <div className={styles.mainLabelSkeleton}>
      <Box flexDirection="column" alignItems="center" gap="space-400">
        <Skeleton borderRadius="radius-400" width={{
          desktop: 450,
          tablet: 450,
          mobile: 280
        }}
          height={{
            desktop: 400,
            tablet: 400,
            mobile: 200
          }}

        />
      </Box>
    </div>
  )
}

export default MainLabelSkeleton
